import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CourseVersion } from '@scaffold/services/version-control.service';
import {
  trigger,
  state,
  transition,
  animate,
  style,
  keyframes,
} from '@angular/animations';

@Component({
    selector: 'app-version-item',
    templateUrl: './version-item.component.html',
    styleUrls: ['../version-control.component.scss'],
    animations: [
        trigger('input', [
            state('in', style({ height: 'auto' })),
            transition('void => *', [
                animate('.3s ease-in', keyframes([
                    style({ opacity: 0, offset: 0 }),
                    style({ opacity: 1, offset: 1 }),
                ])),
            ]),
            transition('* => void', [
                animate('0s ease-in', keyframes([
                    style({ opacity: 1, offset: 0 }),
                    style({ opacity: 0, offset: 1 }),
                ])),
            ]),
        ]),
    ],
    standalone: false
})
export class VersionItemComponent implements OnInit {
  @Input() version: CourseVersion;
  @Input() active: boolean;
  @Output() set_version = new EventEmitter<any>();
  @Output() createFromVersion = new EventEmitter<number>();
  constructor() {}

  ngOnInit() {}

  getVersion(version) {
    console.log('Set Version', version);
    this.set_version.emit(version);
  }

  createFrom() {
    this.createFromVersion.emit(this.version.id);
  }
}
